module.exports = __webpack_public_path__ + "img/30983328.b43c2199.png";